import React from 'react';
import M from 'materialize-css';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch, Redirect, Link } from 'react-router-dom';

import Inicio from './components/Inicio/index';
import Especiales from './components/Especiales/index';
import Publicaciones from './components/Publicaciones/index';
import PaginaError from './components/PaginaError/index';
import LaUnidad from './components/LaUnidad/index';
import LaUnidadEquipo from './components/LaUnidadEquipo/index';
import NosHizoFeliz from './components/NosHizoFeliz/index';
//import AdminLogin from './components/Utilitarios/AdminLogin/index';
import AdminEspeciales from './components/Utilitarios/AdminEspeciales/index';
import AdminEspecialesNuevo from './components/Utilitarios/AdminEspecialesNuevo/index';
import AdminEspecialesActualizar from './components/Utilitarios/AdminEspecialesActualizar/index';
import AdminPublicaciones from './components/Utilitarios/AdminPublicaciones/index';
import AdminPublicacionesActualizar from './components/Utilitarios/AdminPublicacionesActualizar/index';
import AdminEquipo from './components/Utilitarios/AdminEquipo/index';
import AdminEquipoNuevo from './components/Utilitarios/AdminEquipoNuevo/index';
import AdminEquipoActualizar from './components/Utilitarios/AdminEquipoActualizar/index';
import AdminEquipoEliminar from './components/Utilitarios/AdminEquipoEliminar/index';
import AdminError from './components/Utilitarios/AdminError/index';
import AdminExitoso from './components/Utilitarios/AdminExitoso/index';
import AdminInstagramActualizar from './components/Utilitarios/AdminInstagramActualizar/index';
import AdminTwitterActualizar from './components/Utilitarios/AdminTwitterActualizar/index';
import AdminYoutubeActualizar from './components/Utilitarios/AdminYoutubeActualizar/index';
import AdminYoutubeCardActualizar from './components/Utilitarios/AdminYoutubeCardActualizar/index';
import AdminDirectorActualizar from './components/Utilitarios/AdminDirectorActualizar/index';
import AdminBannerActualizar1 from './components/Utilitarios/AdminBannerActualizar1/index';
import AdminBannerActualizar2 from './components/Utilitarios/AdminBannerActualizar2/index';
import AdminBannerActualizar3 from './components/Utilitarios/AdminBannerActualizar3/index';
import AdminImagenCentralActualizar from './components/Utilitarios/AdminImagenCentralActualizar/index';
import AdminEquipoDirectorActualizar from './components/Utilitarios/AdminEquipoDirectorActualizar/index';
import AdminPublicacionesMain from './components/Utilitarios/AdminPublicacionesMain/index';
import AdminPublicacionesMainNuevo from './components/Utilitarios/AdminPublicacionesMainNuevo/index';
import AdminPublicacionesMainActualizar from './components/Utilitarios/AdminPublicacionesMainActualizar/index';
import AdminPublicacionesMainEliminar from './components/Utilitarios/AdminPublicacionesMainEliminar/index';
import AdminImagenQSActualizar1 from './components/Utilitarios/AdminImagenQSActualizar1/index';
import AdminImagenQSActualizar2 from './components/Utilitarios/AdminImagenQSActualizar2/index';
import AdminImagenQHActualizar1 from './components/Utilitarios/AdminImagenQHActualizar1/index';
import AdminImagenQHActualizar2 from './components/Utilitarios/AdminImagenQHActualizar2/index';
import AdminImagenCLHActualizar1 from './components/Utilitarios/AdminImagenCLHActualizar1/index';
import AdminImagenCLHActualizar2 from './components/Utilitarios/AdminImagenCLHActualizar2/index';
import AdminYoutubeCardUnidadActualizar from './components/Utilitarios/AdminYoutubeCardUnidadActualizar/index';
import AdminFelizActualizarImg11 from './components/Utilitarios/AdminFelizActualizarImg11/index';
import AdminFelizActualizarImg12 from './components/Utilitarios/AdminFelizActualizarImg12/index';
import AdminFelizActualizarImg21 from './components/Utilitarios/AdminFelizActualizarImg21/index';
import AdminFelizActualizarImg22 from './components/Utilitarios/AdminFelizActualizarImg22/index';
import AdminFelizActualizarImg31 from './components/Utilitarios/AdminFelizActualizarImg31/index';
import AdminFelizActualizarImg32 from './components/Utilitarios/AdminFelizActualizarImg32/index';
import AdminFelizActualizarTitulo1 from './components/Utilitarios/AdminFelizActualizarTitulo1/index';
import AdminFelizActualizarTitulo2 from './components/Utilitarios/AdminFelizActualizarTitulo2/index';
import AdminFelizActualizarTitulo3 from './components/Utilitarios/AdminFelizActualizarTitulo3/index';
import AdminImagenBannerUnidad from './components/Utilitarios/AdminImagenBannerUnidad/index';

import 'materialize-css/dist/css/materialize.css';
import './css/styles.css';

const { validateStatus } = require('./components/Utilitarios/AdminLogin/utilities/utilities');
let URL = '/api/uip/login/admin';

class App extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            isLogged: false,
        }
        this.getAuth = this.getAuth.bind(this);
    }

    getAuth(){
        if(this.state.isLogged === false){
            this.setState({
                isLogged: true,
            });
        }
        else {
            this.setState({
                isLogged: false,
            });
        }
    }

    render() {
        return(
            <BrowserRouter>
                <div>
                    <Switch>
                        <Route 
                            exact
                            path="/"
                            >
                            <Redirect to="/inicio"/>
                        </Route>
                        <Route 
                            exact
                            path="/inicio"
                            component={Inicio} />
                        <Route 
                            exact
                            path="/especiales" 
                            component={Especiales} />
                        <Route 
                            exact
                            path="/publicaciones" 
                            component={Publicaciones} />
                        <Route 
                            exact
                            path="/launidad"
                            component={LaUnidad}/>
                        <Route 
                            exact
                            path="/equipo"
                            component={LaUnidadEquipo}/>
                        <Route 
                            exact
                            path="/noshizofeliz"
                            component={NosHizoFeliz}/>
                         <Route 
                            exact
                            path="/administrador/login"
                            render={() => <Login getAuth={this.getAuth}/>}/>
                        <Route 
                            exact
                            path="/administrador/especiales"
                            render={(props) => <AdminEspeciales {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/especiales/nuevo"
                            render={(props) => <AdminEspecialesNuevo {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/especiales/actualizar"
                            render={(props) => <AdminEspecialesActualizar {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/proceso/exitoso"
                            render={(props) => <AdminExitoso {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/error/general"
                            render={(props) => <AdminError {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/publicaciones"
                            render={(props) => <AdminPublicaciones {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/publicaciones/actualizar"
                            render={(props) => <AdminPublicacionesActualizar {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/equipo"
                            render={(props) => <AdminEquipo {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/equipo/nuevo"
                            render={(props) => <AdminEquipoNuevo {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/equipo/actualizar"
                            render={(props) => <AdminEquipoActualizar {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/equipo/eliminar"
                            render={(props) => <AdminEquipoEliminar {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/instragram/link/actualizar"
                            render={(props) => <AdminInstagramActualizar {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/twitter/link/actualizar"
                            render={(props) => <AdminTwitterActualizar {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/youtube/link/actualizar"
                            render={(props) => <AdminYoutubeActualizar {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/youtube/card/actualizar"
                            render={(props) => <AdminYoutubeCardActualizar {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/imagen/central/actualizar"
                            render={(props) => <AdminImagenCentralActualizar {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/director/datos/actualizar"
                            render={(props) => <AdminDirectorActualizar {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/banner/actualizar/1"
                            render={(props) => <AdminBannerActualizar1 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/banner/actualizar/2"
                            render={(props) => <AdminBannerActualizar2 {...props} auth={this.state.isLogged}/>}/>
                          <Route 
                            exact
                            path="/administrador/banner/actualizar/3"
                            render={(props) => <AdminBannerActualizar3 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/equipo/director"
                            render={(props) => <AdminEquipoDirectorActualizar {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/publicaciones/principal"
                            render={(props) => <AdminPublicacionesMain {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/publicaciones/principal/nuevo"
                            render={(props) => <AdminPublicacionesMainNuevo {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/publicaciones/principal/actualizar"
                            render={(props) => <AdminPublicacionesMainActualizar {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/publicaciones/principal/eliminar"
                            render={(props) => <AdminPublicacionesMainEliminar {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/equipo/que/somos/1"
                            render={(props) => <AdminImagenQSActualizar1 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/equipo/que/somos/2"
                            render={(props) => <AdminImagenQSActualizar2 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/equipo/que/hacemos/1"
                            render={(props) => <AdminImagenQHActualizar1 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/equipo/que/hacemos/2"
                            render={(props) => <AdminImagenQHActualizar2 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/equipo/como/lo/hacemos/1"
                            render={(props) => <AdminImagenCLHActualizar1 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/equipo/como/lo/hacemos/2"
                            render={(props) => <AdminImagenCLHActualizar2 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/equipo/card/youtube"
                            render={(props) => <AdminYoutubeCardUnidadActualizar {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/nos/hizo/feliz/img/1/1"
                            render={(props) => <AdminFelizActualizarImg11 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/nos/hizo/feliz/img/1/2"
                            render={(props) => <AdminFelizActualizarImg12 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/nos/hizo/feliz/img/2/1"
                            render={(props) => <AdminFelizActualizarImg21 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/nos/hizo/feliz/img/2/2"
                            render={(props) => <AdminFelizActualizarImg22 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/nos/hizo/feliz/img/3/1"
                            render={(props) => <AdminFelizActualizarImg31 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/nos/hizo/feliz/img/3/2"
                            render={(props) => <AdminFelizActualizarImg32 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/nos/hizo/feliz/titulo/1"
                            render={(props) => <AdminFelizActualizarTitulo1 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/nos/hizo/feliz/titulo/2"
                            render={(props) => <AdminFelizActualizarTitulo2 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/nos/hizo/feliz/titulo/3"
                            render={(props) => <AdminFelizActualizarTitulo3 {...props} auth={this.state.isLogged}/>}/>
                        <Route 
                            exact
                            path="/administrador/equipo/imagen"
                            render={(props) => <AdminImagenBannerUnidad {...props} auth={this.state.isLogged}/>}/>
                        <Route component={PaginaError} />
                    </Switch>
                </div>
            </BrowserRouter>
        );
    }
}

class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isAdmin: false,
            failLogin: false,
            user: '',
            pass: '',
            auth: false,
        };
        this.handleChangeUser = this.handleChangeUser.bind(this);
        this.handleChangePass = this.handleChangePass.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentWillMount() {
        M.AutoInit();
        document.body.style.backgroundImage = 'url("/background-1.jpg")';
        document.body.style.backgroundPositionX = 'center';
        document.body.style.backgroundPositionY = 'center';
        document.body.style.backgroundRepeat = 'no-repeat';
        document.body.style.backgroundAttachment = 'fixed';
        document.body.style.backgroundSize = 'cover';
    }

    handleFormSubmit(event) {
        if(this.state.failLogin === false){
            event.preventDefault();
            let login = {};
            login.user = this.state.user;
            login.pass = this.state.pass;
            fetch(URL, {
                method: 'POST',
                body: JSON.stringify(login),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(res => validateStatus(res))
                .then(() => this.setState({ isAdmin: true }))
                .catch(res => this.handleCatchLogin())
        }
        if(this.state.failLogin === true){
            event.preventDefault();
            this.setState({
                user: '',
                code: '',
                failLogin: false
            })
        }
        
    }

    handleChangeUser(event) {
        let stateForm = {};
        stateForm.user = event.target.value;
        this.setState({ user: stateForm.user });
    }

    handleChangePass(event) {
        let stateForm = {};
        stateForm.pass = event.target.value;
        this.setState({ pass: stateForm.pass });
    }

    handleCatchLogin(){
        this.setState({failLogin: true});
        let stateForm = {};
        stateForm.user = 'Usuario o Contraseña Invalidos';
        stateForm.code = 'Usuario o Contraseña Invalidos';
        this.setState({
            user: stateForm.user,
            code: stateForm.pass,
        })
    }

    render() {

        if (this.state.isAdmin === true) {
            return <Redirect to="/administrador/especiales"/>
        }

        if(this.state.failLogin === true){
            return(
                <FormLogin
                    handleFormSubmit={event => this.handleFormSubmit(event)}
                    handleChangeUser={event => this.handleChangeUser(event)}
                    handleChangeCode={event => this.handleChangePass(event)} 
                    getAuth={this.props.getAuth}
                    cardColor={`pink accent-3`}
                    buttonColor={`pink accent-3`}
                    buttonText={`regresar`}
                    isInputDisabled='disabled'
                    textCardTittle='Error'
                    userInput={this.state.user}
                    userPass={this.state.code}/>
            );
        }

        return (
            <FormLogin
                handleFormSubmit={event => this.handleFormSubmit(event)}
                handleChangeUser={event => this.handleChangeUser(event)}
                handleChangeCode={event => this.handleChangePass(event)} 
                getAuth={this.props.getAuth}
                cardColor={`light-blue`}
                buttonColor={`light-blue`}
                buttonText={`ingresar`}
                isInputDisabled=''
                textCardTittle='Login'
                userInput={this.state.user}
                userPass={this.state.code}/>
        );
    }
}

class FormLogin extends React.Component {

    render() {

        return (
            
            <div className="row">
                <div className="col s12 m2 l2 xl4"></div>
                <div className="col s12 m8 l8 xl4">
                    <div className="card">
                        <div className={`card-content ${this.props.cardColor} white-text`}>
                            <span className="card-title">{this.props.textCardTittle}</span>
                        </div>
                        <div className="card-content">
                            <div className="row">
                                <form 
                                    className="col s12" 
                                    autoComplete="off"
                                    onSubmit={this.props.handleFormSubmit}>
                                    <div className="row">
                                        <div className="input-field col s12">
                                            <input 
                                                disabled={this.props.isInputDisabled} 
                                                id="text" 
                                                type="text" 
                                                className="validate" 
                                                name="user"
                                                placeholder="tu usuario Poli"
                                                value={this.props.userInput}
                                                onChange={this.props.handleChangeUser} />
                                                <label htmlFor="text" className="active">Usuario</label>                                            
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="input-field col s12">
                                            <input 
                                                disabled={this.props.isInputDisabled} 
                                                id="password" 
                                                type="password" 
                                                className="validate" 
                                                name="code"
                                                placeholder="tu contraseña"
                                                value={this.props.userPass}
                                                onChange={this.props.handleChangeCode} />
                                            <label htmlFor="password" className="active">Contraseña</label>
                                        </div>
                                    </div>
                                    <div className="row center-align">
                                        <button 
                                            className={`btn waves-effect waves-light ${this.props.buttonColor}`} 
                                            type="submit" 
                                            name="action"
                                            onClick = {this.props.getAuth}>
                                            {this.props.buttonText}
                                            <i className="material-icons right">send</i>
                                        </button>
                                        <br />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col s12 m2 l2 xl4"></div>
            </div>
            
        );
    }
}


// ====================================================

ReactDOM.render(
    <App />,
    document.getElementById('root')
);